import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SemPararEmpresasService } from 'src/app/services/sem-parar-empresas/sem-parar-empresas.service';
import { showError } from 'src/utils/showErrorMessage';

@Component({
    selector: 'spe-vb-abastecimento',
    templateUrl: './vb-abastecimento.component.html',
    styleUrls: ['./vb-abastecimento.component.scss'],
    standalone: false
})
export class VbAbastecimentoComponent implements OnInit {
  constructor(private semPararService: SemPararEmpresasService, private router: Router, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.getUrl('AUTO');
  }

  getUrl(produto: string) {
    let cnpj = localStorage.getItem('cnpj') ?? '';
    this.semPararService.consulta(cnpj, produto).subscribe({
      next: (response) => {
        window.open(response);
      },
      error: (error) => {
        showError(this.dialog, error.error.mensagem);
        this.router.navigate(['home']);
      }
    });
  }
}
